<template>
	<div class="container-xl px-4">
		<ProfileNav />
		<div class="row">
			<div class="col-md-9">
				<!-- Account details card-->
				<div class="card mb-4">
					<div class="card-header d-flex justify-content-between align-items-center">
						Профиль
						<button class="btn btn-sm btn-outline-primary" type="button" v-show="!editMode" @click="toggleForm()">
							<font-awesome-icon icon="fa-user-pen" size="2xs" />
						</button>
					</div>
					<div class="card-body">
						<form>
							<fieldset :disabled="!editMode">
								<!-- Form Row-->
								<div class="row gx-3 mb-3">
									<!-- Form Group (first name)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputLastName">Фамилия <sup>*</sup></label>
										<input
											class="form-control"
											id="inputLastName"
											type="text"
											placeholder="Укажите вашу фамилию"
											v-model="userProfile.lastName"
										/>
									</div>
									<!-- Form Group (last name)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputFirstName">Имя <sup>*</sup></label>
										<input
											class="form-control"
											id="inputFirstName"
											type="text"
											placeholder="Укажите ваше имя"
											v-model="userProfile.firstName"
										/>
									</div>
								</div>
								<!-- Form Row-->
								<div class="row gx-3 mb-3">
									<!-- Form Group (Middle name)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputMiddleName">Отчество <sup>*</sup></label>
										<input
											class="form-control"
											id="inputMiddleName"
											type="text"
											placeholder="Укажите ваше отчество"
											v-model="userProfile.middleName"
										/>
									</div>
									<!-- Form Group (last name)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputBirthday">Дата рождения <sup>*</sup></label>
										<br />
										<date-picker
											id="inputBirthday"
											input-class="form-control"
											prefix-class="xmx"
											v-model="userProfile.birthday"
											type="date"
											v-mask="mask.date"
											valueType="date"
											format="DD.MM.YYYY"
											:disabled="!editMode"
										></date-picker>
									</div>
								</div>

								<!-- Form Row-->
								<div class="row gx-3 mb-3">
									<!-- Form Group (phone number)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputPhone">Телефон <sup>*</sup></label>
										<input
											class="form-control"
											id="inputPhone"
											type="tel"
											placeholder="Укажите ваш телефон"
											v-mask="mask.phone"
											v-model="userProfile.phone"
										/>
									</div>
									<!-- Form Group (birthday)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputEmailAddress">Email <sup>*</sup></label>
										<input
											class="form-control"
											id="inputEmailAddress"
											type="email"
											placeholder="Укажите ваш email"
											v-model="currentUser.email"
											disabled
										/>
									</div>
								</div>
								<!-- Form Row        -->
								<div class="row gx-3 mb-3">
									<!-- Form Group (organization name)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputOrgName">Пол <sup>*</sup></label>
										<div class="form-control gender text-center" :class="!editMode ? 'disabled' : ''">
											<div class="form-check form-check-inline">
												<input
													class="form-check-input"
													type="radio"
													name="gender"
													id="genderMale"
													value="male"
													v-model="userProfile.gender"
												/>
												<label class="form-check-label" for="genderMale">Мужской</label>
											</div>
											<div class="form-check form-check-inline">
												<input
													class="form-check-input"
													type="radio"
													name="gender"
													id="genderFemale"
													value="female"
													v-model="userProfile.gender"
												/>
												<label class="form-check-label" for="genderFemale">Женский</label>
											</div>
										</div>
									</div>
									<!-- Form Group (location)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputSnils">СНИЛС</label>
										<input
											class="form-control"
											id="inputSnils"
											type="text"
											placeholder="Укажите ваш СНИЛС"
											v-mask="mask.snils"
											v-model="userProfile.snils"
										/>
									</div>
								</div>

								<!-- Form Row-->
								<div class="row gx-3 mb-3">
									<!-- Form Group (phone number)-->
									<div class="col-md-6">
										<label class="small mb-1" for="inputSchool">Образовательное учреждение <sup>*</sup></label>

										<multiselect
											v-model="selectedSchool"
											id="ajax"
											label="name"
											placeholder="Поиск школы"
											deselect-label="Нельзя отменить"
											selectLabel=" "
											selectedLabel="Выбрано"
											deselectLabel=" "
											track-by="name"
											:options="schoolsList"
											:multiple="false"
											:searchable="true"
											:loading="selectIsLoading"
											:options-limit="50"
											:limit="3"
											:max-height="600"
											:show-no-results="true"
											:hide-selected="false"
											:disabled="!editMode"
											@search-change="schoolFind"
											@input="onChangeSchool"
											:taggable="true"
											@tag="addSchool"
											tag-placeholder="Нажмите ТУТ для добавления"
										>
											<span slot="noResult">Упс. Ничего не нашлось.</span>
											<span slot="noOptions">Начните писать название/номер</span>
										</multiselect>
									</div>
									<!-- Form Group (school)-->
									<div class="col-md-3 col-6">
										<label class="small mb-1" for="inputClass">Класс (цифра)</label>
										<input
											class="form-control"
											id="inputClass"
											type="text"
											placeholder="Укажите класс"
											v-model="userProfile.class"
										/>
									</div>
									<div class="col-md-3 col-6">
										<label class="small mb-1" for="inputСlassChar">Класс (литера)</label>
										<input
											class="form-control"
											id="inputСlassChar"
											type="text"
											placeholder="Укажите букву"
											v-model="userProfile.classChar"
										/>
									</div>
								</div>
								<!-- Save changes button-->
								<div v-if="editMode">
									<button class="btn btn-primary" type="button" @click="updateProfile(userProfile)">
										Сохранить изменения
									</button>
									&nbsp;
									<button class="btn btn-danger mt-1 mt-sm-0" type="button" :disabled="!editMode" @click="toggleForm()">
										Отмена
									</button>
									{{ message }}
								</div>
								<div class="text-muted text-center">{{ editModeRes }}</div>
							</fieldset>
						</form>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<!-- Profile picture card-->
				<div class="card mb-4">
					<div class="card-header" @dblclick="toggleDebug()">Аватар</div>
					<div class="card-body text-center">
						<!-- Profile picture image-->
						<img
							class="img-account-profile rounded-circle mb-2"
							:src="userProfile.gender ? getAvatar(userProfile.gender) : getAvatar('no_gender')"
							alt="Avatar"
						/>
						<!-- Profile picture help block-->
						<div class="small font-italic text-muted mb-4" v-if="false">&nbsp;</div>
						<!-- Profile picture upload button-->
						<button class="btn btn-sm btn-primary" v-if="false" disabled type="button">Изменить</button>
					</div>
				</div>
				<div class="card mb-4" :class="!debugActive ? 'd-none' : ''">
					<div class="card-header">Debug</div>
					<div class="card-body">
						ID: {{ currentUser.id }} <br />
						Registered: {{ currentUser.createdAt }}<br />
					</div>
				</div>
			</div>
		</div>
		<sweet-modal icon="success" ref="okModal">
			{{ successMsg }}
			<sweet-button class="btn btn-success" slot="button" @click="closeModal()"> Ок</sweet-button>
		</sweet-modal>
		<sweet-modal icon="error" blocking ref="errModal">
			<div v-html="errorMsg"></div>
			<sweet-button class="btn btn-danger" slot="button" @click="closeModal()"> Закрыть</sweet-button>
			<!-- <sweet-button class="btn btn-danger" v-if="errorRoute" slot="button" @click="goToRoute(errorRoute)"
				>Заполнить</sweet-button
			> -->
		</sweet-modal>
	</div>
</template>

<script>
import moment from "moment";
import ProfileNav from "../components/profile/TopNav.vue";
import UserService from "../services/user.service";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "../assets/css/datepicker.scss";
import "vue2-datepicker/locale/ru";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
const schoolsJson = require("../assets/json/schools.json");

export default {
	name: "profile",
	metaInfo: {
		title: "Личный кабинет",
		meta: [{ name: "description", content: "Личный кабинет" }],
	},
	components: { ProfileNav, Multiselect, DatePicker },
	data() {
		return {
			content: "_",
			editMode: false,
			editModeRes: "",
			message: null,
			fullSchoolList: [],
			selectIsLoading: false,
			selectedSchool: [],
			schoolsList: [],
			userProfile: {
				firstName: "",
				lastName: "",
				middleName: "",
				birthday: "",
				gender: "",
				phone: "",
				snils: "",
				school: "",
				class: "",
				classChar: "",
			},
			excludeFields: ["snils", "class", "classChar"],
			mask: {
				phone: "+7 (###) ###-##-##",
				date: "##.##.####",
				snils: "###-###-### ##",
			},
			successMsg: "",
			errorMsg: "",
			errorRoute: null,
			debugActive: false,
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.auth.user;
		},
		userProfileState() {
			return this.$store.state.user.profile;
		},
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},
	methods: {
		async toggleForm() {
			this.editMode = !this.editMode;
			await this.getProfile();
		},

		toggleDebug() {
			this.debugActive = !this.debugActive;
		},

		async schoolFind(query) {
			this.selectIsLoading = true;
			this.schoolsList = this.fullSchoolList.filter((school) => school.name.search(new RegExp(query, "i")) != -1);
			this.selectIsLoading = false;
		},

		onChangeSchool(option) {
			this.userProfile.school = option.name;
		},

		async updateProfile(data) {
			for (let field in data) {
				if ((data[field] == "" || data[field] === null) && !this.excludeFields.includes(field)) {
					this.errorMsg = "Необходимо заполнить все обязательные поля<br>(Помечены звездочкой - * )";
					this.$refs.errModal.open();
					return;
				}

				if (field == "birthday") {
					const d = new Date(data.birthday);
					data.birthday = moment(d).toISOString();
				}
			}

			let userData = await UserService.updateUserProfile(data);

			if (!userData.data.success) {
				this.message = userData.data.message;
				return;
			}

			this.message = null;
			await this.getProfile();

			this.$store.commit("user/UPDATE_PROFILE", this.userProfile, { root: true });
			this.editMode = false;
			this.editModeRes = "Данные обновлены";
			this.successMsg = "Данные обновлены";
			this.$refs.okModal.open();

			setTimeout(
				function () {
					this.editModeRes = "";
				}.bind(this),
				3000
			);
		},
		getAvatar(gender) {
			let images = require.context("./../assets/img/profile/", false, /\.png$/);
			return images("./" + gender + ".png");
		},

		async getProfile() {
			if (!this.loggedIn || !this.currentUser) {
				this.$store.dispatch("auth/logout");
				this.$router.push("/login");
			}

			await this.$store.dispatch("user/getProfile");
			this.userProfile = this.userProfileState;

			if (this.userProfile.school != "") {
				let foundSchool = this.fullSchoolList.find((option) => option.name === this.userProfile.school);
				if (foundSchool !== undefined) {
					this.selectedSchool = foundSchool;
				} else {
					this.addSchool(this.userProfile.school);
				}
			}

			if (this.userProfile.birthday !== null) {
				this.userProfile.birthday = new Date(this.userProfile.birthday);
			} else {
				this.userProfile.birthday = "";
			}
		},

		closeModal() {
			this.$refs.okModal.close();
			this.$refs.errModal.close();
		},
		addSchool(newTag) {
			const tag = {
				id: Math.floor(Math.random() * 9999999),
				name: newTag,
			};
			this.fullSchoolList.push(tag);
			this.selectedSchool = tag;
			this.userProfile.school = tag.name;
		},
	},
	async created() {
		await this.getProfile();
		for (let field in this.userProfile) {
			if ((this.userProfile[field] == "" || this.userProfile[field] === null) && !this.excludeFields.includes(field)) {
				this.editMode = true;
				return;
			}
		}
	},
	mounted() {
		this.fullSchoolList = schoolsJson.map((school) => {
			return {
				id: parseInt(school.global_id),
				name: school.Cells.ShortName,
			};
		});
	},
};
</script>

<style>
.v-application ul.multiselect__content {
	padding-left: 0;
}
.multiselect__tags {
	min-height: 46px;
	border-color: #c5ccd6;
	padding-top: 14px;
}
.multiselect__select {
	min-height: 44px;
}

.multiselect--disabled,
.multiselect--disabled .multiselect__tags,
.multiselect--disabled .multiselect__single {
	background-color: #e9ecef;
	opacity: 1;
}
.img-account-profile {
	height: 10rem;
}
.rounded-circle {
	border-radius: 15% !important;
}
.card {
	box-shadow: 0 0.15rem 1.75rem 0 rgb(33 40 50 / 15%);
}
.card .card-header {
	font-weight: 500;
}
.card-header:first-child {
	border-radius: 0.35rem 0.35rem 0 0;
}
.card-header {
	padding: 1rem 1.35rem;
}
.card-header .btn-sm {
	padding: 0.05rem 0.5rem;
	font-size: 0.865rem;
}
.form-control,
.dataTable-input {
	display: block;
	width: 100%;
	padding: 0.875rem 1.125rem;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1;
	color: #69707a;
	/* background-color: #fff; */
	background-clip: padding-box;
	border: 1px solid #c5ccd6;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.35rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

label sup {
	top: 0;
	font-size: large;
}

.form-control.gender {
	padding: 0.275rem 1.125rem;
}

.form-control.gender.disabled {
	background-color: #e9ecef;
	opacity: 1;
}

.form-control.gender .form-check-inline {
	margin-top: 0.7rem;
}

.anotherSchoolTrigger {
	text-decoration: underline;
}
</style>
